/**
 * Configuration for Concord Monitor frontend
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
// Place the currency symbol before the price.
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Mondadnock Ledger-Transcript',
    SITE_DESCRIPTION: 'Mondadnock Ledger-Transcript',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/ledgertranscript/logo.png',
      faviconsPath: '/static/ledgertranscript',
    },
    OG_IMAGE: '/static/ledgertranscript/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#000000',
        secondary: '#808080',
      },
    },
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-BK68S98W8B'],
  },
});
